"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useAcListedDataList = function (config) {
    var _a = config || {}, initialSorts = _a.initialSorts, initialFilter = _a.initialFilter;
    var _b = react_1.useState(initialSorts), sorts = _b[0], setSorts = _b[1];
    var _c = react_1.useState(initialFilter), filter = _c[0], setFilter = _c[1];
    var updateFilter = function (updatedFilter) {
        setFilter(updatedFilter);
    };
    var updateSorts = function (updatedSorts) {
        setSorts(updatedSorts);
    };
    return {
        sorts: sorts,
        setSorts: setSorts,
        filter: filter,
        updateFilter: updateFilter,
        updateSorts: updateSorts,
    };
};
//# sourceMappingURL=UseAcListedDataList.js.map